// File: frontend/src/layouts/RightPane.tsx

import React from "react";
import { AdSlot } from "../components/ads";
import "./RightPane.css";

// Static pane with no props — memoized so it never re-renders when the parent
// AppContent re-renders (e.g. on the Yenile refresh or new-entry poll tick).
//
// AdSlot handles its own consent check and falls back to a placeholder when
// REACT_APP_ADSENSE_CLIENT is unset, so this stays a plain layout component.
const RightPaneComponent: React.FC = () => {
  return (
    <aside className="right-pane">
      <AdSlot
        slot={process.env.REACT_APP_ADSENSE_SLOT_RIGHT ?? ""}
        format="vertical"
        height={600}
        className="right-pane__ad"
      />
    </aside>
  );
};

export const RightPane = React.memo(RightPaneComponent);